const STAR_GOLD_WHATSAPP = "918897864796";

export const openWhatsApp = (message) => {
  const encodedMessage = encodeURIComponent(message);

  const url = `https://wa.me/${STAR_GOLD_WHATSAPP}?text=${encodedMessage}`;

  window.open(url, "_blank", "noopener,noreferrer");
};

export const createProductWhatsAppMessage = (product) => {
  const price = product.salePrice ?? product.price;

  return `Hello STAR GOLD,

I am interested in this product:

Product: ${product.name}
Category: ${product.category}
Price: ₹${price}

Could you please provide more details?

Thank you.`;
};

export const createCartWhatsAppMessage = (cartItems, total) => {
  let message =
    "Hello STAR GOLD,\n\n" +
    "I would like to enquire about these products:\n\n";

  cartItems.forEach((item, index) => {
    const price = item.salePrice ?? item.price;

    message +=
      `${index + 1}. ${item.name}\n` +
      `Quantity: ${item.quantity}\n` +
      `Price: ₹${price}\n\n`;
  });

  message +=
    `Estimated Total: ₹${total}\n\n` +
    "Please confirm availability and delivery details.\n\n" +
    "Thank you.";

  return message;
};
